import FingerprintJS, {GetResult} from '@fingerprintjs/fingerprintjs'
import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";

export class Fingerprint extends AbstractPage {
    protected result: GetResult = null;

    constructor(app: JqueryApp) {
        super(app);

        // commercial version with server-side support: https://dev.fingerprint.com/docs/introduction
        // https://fingerprint.com/github/
    }

    public async load(submit: boolean = true): Promise<void> {
        const fpPromise = FingerprintJS.load();

        const fp = await fpPromise;
        this.result = await fp.get();
        //console.log(this.result)
        if (submit === true)
            this.send();
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected send(): void {
        try {
            const config = this.app.getConfig();
            const url = config.apiBase + config.pathFingerprint;
            const fullToken = config.payment.token + "-" + config.payment.merchantId;
            const data = {
                tx_id: fullToken,
                data: this.result.visitorId,
                version: this.result.version,
                score: this.result.confidence.score,
            }
            this.app.getWebHelpers().postApi(url, data, (data) => {
                if (!data || data.error) {
                    console.error("Error sending fingerprint", data);
                    return;
                }
            });
        }
        catch (err) {
            console.error("Exception on fingerprint", err);
        }
    }
}
